import AutoScroll from 'embla-carousel-auto-scroll'
import Autoplay from 'embla-carousel-autoplay'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Carousel as MantineCarousel } from '@mantine/carousel'
import { Stack, Title } from '@mantine/core'
import { useAppState } from '@/features/app/hooks'
import { ROLE } from '@/features/user/types'
import useStyles from './SectionPartners.styles'
import img2 from './assets/4.svg'
import img3 from './assets/5.svg'
import img4 from './assets/6.png'
import img5 from './assets/7.svg'
import img6 from './assets/8.svg'
import img7 from './assets/23.svg'
import img15 from './assets/Palacio de Seteais.svg'
import img8 from './assets/allianz.svg'
import img9 from './assets/aqualuz.svg'
import img10 from './assets/capricciosa.svg'
import img11 from './assets/champalimaud.svg'
import img12 from './assets/maison albar amoure.svg'
import img13 from './assets/marie.svg'
import img14 from './assets/octant.svg'
import img16 from './assets/parceiros-anantara.svg'
import img17 from './assets/parceiros-jncquoi.svg'
import img18 from './assets/parceiros-pine-cliffs-resort.svg'
import img19 from './assets/pestana-douro.svg'
import img20 from './assets/rede elo farma.svg'
import img21 from './assets/ripe ncc.svg'
import img22 from './assets/sales force.svg'
import img1 from './assets/tivoli-vilamoura.svg'

type SlideType = {
  img: any
}

interface IProps {
  role?: ROLE
}

export const SectionPartners = ({ role }: IProps) => {
  const { classes } = useStyles()

  const { t } = useTranslation()

  //const autoplay = useRef(Autoplay({ delay: 1000 }))

  const autoScroll = useRef(
    AutoScroll({
      speed: 1,
      playOnInit: true,
      stopOnInteraction: true,
      stopOnMouseEnter: true,
    })
  )
  const defaultSlides: Array<SlideType> = [
    {
      img: img1,
    },
    {
      img: img2,
    },
    {
      img: img3,
    },
    {
      img: img4,
    },
    {
      img: img5,
    },
    {
      img: img6,
    },
    /*{
      img: img7,
    },*/
    {
      img: img8,
    },
    {
      img: img9,
    },
    {
      img: img10,
    },
    {
      img: img11,
    },
    {
      img: img12,
    },
    {
      img: img13,
    },
    {
      img: img14,
    },
    {
      img: img15,
    },
    {
      img: img16,
    },
    {
      img: img17,
    },
    {
      img: img18,
    },
    {
      img: img19,
    },
    {
      img: img20,
    },
    {
      img: img21,
    },
    {
      img: img22,
    },
  ]

  const slides: Array<SlideType> = defaultSlides

  const {
    appState: { mobileView },
  } = useAppState()

  const renderSlide = ({ img }: SlideType) => (
    <img src={img} height={mobileView ? '50px' : '70px'} />
  )

  return (
    <Stack className={classes.stack}>
      <Title className={classes.text}>{t('book.trusted_by')}</Title>
      <MantineCarousel
        withControls={false}
        initialSlide={mobileView ? 4 : 6}
        loop
        height={mobileView ? '50px' : '90px'}
        slideSize={mobileView ? '40%' : '10%'}
        draggable={false}
        //plugins={[autoplay.current]}
        plugins={[autoScroll.current as any]}
        //emblaOptions={{ containScroll: 'trimSnaps' }} // perfect seams
        //onMouseEnter={autoScroll.current.stop}
        //onMouseLeave={autoScroll.current.reset}
        //styles={(theme: any) => ({
        //root: { height: '100%', overflow: 'hidden' },
        //viewport: { height: '100%' },
        //indicators: {
        //bottom: '60px',
        //right: mobileView ? 0 : '-80px',
        //width: 12,
        //height: 12,
        //transition: 'width 3500ms ease',
        //border: `2px solid ${theme.white}`,
        //background: 'transparent',
        //opacity: 1,

        //'&[data-active]': {
        //background: theme.white,
        //},
        //},
        //})}
      >
        {slides.map((item, i) => (
          <MantineCarousel.Slide key={i}>{renderSlide(item)}</MantineCarousel.Slide>
        ))}
      </MantineCarousel>
    </Stack>
  )
}
